import React, { useState, useEffect } from "react";
import classes from "./locationcontrols.module.scss";
import {
    FormControl,
    TextField,
    Button,
    Grid
  } from '@mui/material';   
import { Icon,DatePicker } from '@genesis/ui-kit';
import axios from "axios";
import axiosInstance from "../../../../Shared/Utill/AxiosConfig";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { methods } from "underscore";
import { useNavigate, NavLink,useLocation } from "react-router-dom";
import { constants } from "../../../../Shared/Url/Constants";
import { CheckIsUserAdmin, convertDateToMMDDYYYYString,toUpperCaseString } from "../../../../Shared/Utill/Utills";
import AdminControlsDataGrid from '../../AdminControlsDataGrid';
import UnpublishedOutlinedIcon from '@mui/icons-material/UnpublishedOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import SnackBar from "../../../../Shared/Snackbar/Snackbar";
import DivisionDropDownComp from "../../DivisionDropdown/DivisionDropdownComp";
import { AddPlusIcon } from "../../../../Resources/availabilityicon/IconUtils";
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreHoriz';
import EventLocationsDialog from "../../EventParentControls/EventLocationsList/EventLocationsDialog";
import DeleteEventDialog from "./DeleteEventDialog"
import DuplicateEventDialog from "./DuplicateEventDialog"
import LocationControlsDataGrid from "./LocationControlsDataGrid";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Dialog, useToggle } from '@genesis/ui-kit';
import { isString } from '../../../../Shared/Utill/Utills';
import { AllControlSearchView } from "../RuleAssignments/Search/RuleAssignmentsSearch";
import moment from 'moment';

const LocationControlsSearch = () => {
    const personDetails = useSelector((state) => state.personStatic.personStaticData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const token = Cookies.get('X_TKN');
    const navigate = useNavigate();
    const [divSelectedValue, setDivSelectedValue] = useState(null);
    const [prefLocation, setPrefLocation] = useState("");
    const [preferenceGroup, setPreferenceGroups] = useState("");
   
    const [searchApiValue, setSearchApiValue] = useState([]);
    const [isAlertOpen, setAlertOpen] = React.useState({});
    const { message, severity, open } = isAlertOpen || {};
    const [searchValue, setSearchValue] = useState([]);
    const [deleteDiv,setDeleteDiv] = useState("");
    const [deleteLoc,setDeleteLoc] = useState("");
    const [duplicDiv,setDuplicDiv] = useState("");
    const [duplicLoc,setDuplicLoc] = useState("");
    const history = useNavigate();
    
    const ITEM_HEIGHT = 48;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const openOption = Boolean(anchorEl);
    const dialog = useToggle();
    const [openLocDialog, setOpenLocDialog] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [selectedLocLinkData, setSelectedLocLinkData] = useState(null);
    const [options, setMenuOptions] = useState([
      'Edit',
      'Duplicate',
      'Delete',    
    ]);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [openDuplicateDialog, setOpenDuplicateDialog] = useState(false);

    const location = useLocation();
    const searchFlag = "S";
    

    // check user role at page
    CheckIsUserAdmin();

    useEffect(() => {
      let isDeleteSuccess = location.state !== null ? true : false;
      //console.log("WHAT IS THIS" + prefLocation.stateDelete)
      //console.log("WHAT IS THIS 2" + location.state)
      if(isDeleteSuccess){
        setAlertOpen({
          open: true,
          severity: "success",
          message : location.state.message,
        })
      }
    },[]);

  const onDivDropDownSelect = (selectedDivision) => {
    setDivSelectedValue(selectedDivision);
  }
  

  const handleAlertNotifClose = () => {
     setAlertOpen({});
  };


  // option menu callbacks
  const handleClick = (event,data) => {
    console.log("data should be right here: "+ JSON.stringify(data))
      setAnchorEl(event.currentTarget);
      setSelectedRowData(data);
    };

  const handleClose = (event) => {
      setAnchorEl(null);
    };

  const handleOptionMenuClick = (event,params) => {
      setAnchorEl(null);
      let optionClicked = event.nativeEvent.target.outerText;
      //let myData = selectedRowData;
      
      if(optionClicked == 'Edit'){
        history("Edit", { state: {flag: "E", id: params.id, data:params}});
      }
  
      if(optionClicked == 'Delete'){
        //alert(JSON.stringify(params.prefLocation))
        showDeleteDialog(params.divnbr, params.prefLocation)
      }
  
      if(optionClicked == 'Duplicate'){
        history("Duplicate", { state: {flag: "E", id: params.id, data:params,copy:true,dup:"D",isSearch: true}});
      }
    }

    const showDeleteDialog = (div, location) => {
        //setDeleteId(id);
        //setDeleteName(name);
        setDeleteDiv(div)
        setDeleteLoc(location)
        setOpenDeleteDialog(true)
        //dialog.show()
    }

    const showDuplicateDialog = (div,location) => {
        //setDeleteId(id);
        //setDeleteName(name);
        setDuplicDiv(div)
        setDuplicLoc(location)
        setOpenDuplicateDialog(true)
        //dialog.show()
    }


  //------
    const handleSearch = () => {
      let searchData = [];
      
      


      if (divSelectedValue === null) {
        setAlertOpen({
          open: true,
          severity: "error",
          message : "Please Select Division",
        })

        if (!isString(prefLocation)) {
        setAlertOpen({
          open: true,
          severity: "error",
          message : "Location field must be a number",
        })
      }

      }
       else {
        let data = {
        divNbr: divSelectedValue.divNbr,
        locNbr: prefLocation != "" ? prefLocation : null,
    }

     axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAILABILITY_LOCATION_CONTROLS_SEARCH}`, 
     data,
      {
        headers:{
        'Content-Type': 'application/json',
        'Authorization':'Bearer ' + token,
        }
      }).then((res) => {
        let tmparr = [];
        let a = 1;
       console.log("response",res.data);
       res.data.map(obj => {
        let tmpobj = {} 
        tmpobj.id = a;
        tmpobj.appid = obj.appId
        tmpobj.divnbr = obj.divNbr;
        tmpobj.division = obj.divNameDisplay;
        tmpobj.prefLocation = obj.locNbr;
        tmpobj.locid = obj.locId
        tmpobj.store_status = obj.storeStatus === 'y' ? 'Active' : 'Inactive';
        tmpobj.newhire_status = obj.newHireStatus === 'y' ? 'Active' : 'Inactive';
        tmpobj.workschedule_status = obj.workScheduleStatus === 'y' ? 'Active' : 'Inactive';
        tmparr.push(tmpobj);
        a++;
        console.log("obj",tmparr)
      });
      setSearchApiValue(res.data);
      setSearchValue(tmparr);
      }).catch((err) => {
       setAlertOpen({
          open: true,
          severity: "error",
          message : "Something went wrong",
        })
      });
       }
      
    }
    
 /* const handleLocClick = (rowdata) => {
    console.log("Locations Clicked" + JSON.stringify(rowdata) );
    setOpenLocDialog(true);
    setSelectedLocLinkData(rowdata);
  } */

      
  const onCloseDialog = () => {
    setOpenLocDialog(false);
    setOpenDeleteDialog(false);
    setOpenDuplicateDialog(false);
  }

  const onDeleteCallback = (responseType,message) => {
    onCloseDialog();
    //handle success / failue
    setAlertOpen({
      open: true,
      severity: responseType,
      message : message,
    });
    // refresh data
    if(responseType == 'success'){
      handleSearch();
    }
  }

  const onDuplicateCallback = (responseType,message,resp) => {
    onCloseDialog();
    //handle success / failue
    setAlertOpen({
      open: true,
      severity: responseType,
      message : message,
    });
    // refresh data
    if(responseType == 'success'){
      handleSearch();
    }
  }

  
  const columns = 
  [
    { field: 'division', headerName: 'Division', width: "100" },
    { field: 'prefLocation', headerName: 'Location', width: "100"},
    { field: 'store_status', headerName: 'Store Status', width: "100", renderCell: (params) => {
        if(toUpperCaseString(params.row.store_status) === "ACTIVE") {
          return (
          <div
            className="d-flex justify-content-between align-items-center"
            
          >
          <CheckCircleOutlinedIcon style={{color:"#008757"}} /> <span style={{marginLeft:"5px" }}>Active</span>
          </div>);
        } else {
        return (
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer" }}
          >
          <UnpublishedOutlinedIcon /> <span style={{marginLeft:"5px" }}> Inactive </span>
          </div>
        
        );
        }
      }},
      { field: 'newhire_status', headerName: 'New Hire Status', width: "120", renderCell: (params) => {
        if(toUpperCaseString(params.row.newhire_status) === "ACTIVE") {
          return (
          <div
            className="d-flex justify-content-between align-items-center"
            
          >
          <CheckCircleOutlinedIcon style={{color:"#008757"}} /> <span style={{marginLeft:"5px" }}>Active</span>
          </div>);
        } else {
        return (
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer" }}
          >
          <UnpublishedOutlinedIcon /> <span style={{marginLeft:"5px" }}> Inactive </span>
          </div>
        
        );
        }
      }},
      { field: 'workschedule_status', headerName: 'Work Schedule Status', width: "160", renderCell: (params) => {
        if(toUpperCaseString(params.row.workschedule_status) === "ACTIVE") {
          return (
          <div
            className="d-flex justify-content-between align-items-center"
            
          >
          <CheckCircleOutlinedIcon style={{color:"#008757"}} /> <span style={{marginLeft:"5px" }}>Active</span>
          </div>);
        } else {
        return (
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer" }}
          >
          <UnpublishedOutlinedIcon /> <span style={{marginLeft:"5px" }}> Inactive </span>
          </div>
        
        );
        }
      }},
    {
        field: 'actions', headerName: 'Actions', width: "100", disableColumnMenu:true, renderCell: (params) => {
            console.log("location controls", params.row)
            let isDeleteDisable = params.row.prefLocation == "0";
            let delColor = isDeleteDisable ? "gray2" : "gray";
            let haveDiv = params.row.divnbr !== undefined;
            console.log("hehehehehehe "+JSON.stringify(searchApiValue))
            /*var result = searchApiValue.find(function(e) {
              return e.recordSequenceId == params.row.id;
            });*/
            return( 
            <div>
              <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={openOption ? 'long-menu' : undefined}
                aria-expanded={openOption ? 'true' : undefined}
                aria-haspopup="true"
                onClick={(event) => handleClick(event, params.row)}
              >
                <MoreVertIcon /> <div></div>
              </IconButton>
              <Menu
                id="long-menu"
                MenuListProps={{
                  'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={openOption}
                onClose={handleClose}
                PaperProps={{
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: '15ch',
                  },
                }}
              >
                {options.map((option) => (
                  <>
                  {console.log("FIX DELETE "+JSON.stringify(selectedRowData))}
                  {(selectedRowData) &&
                  <MenuItem key={option} 
                    value={option} 
                    className={classes.menu_item} 
                    onClick={(event) => handleOptionMenuClick(event,selectedRowData)} >
                    {option}
                  </MenuItem>
                  }
                  </>
                ))}
              </Menu>
            </div>
           /* return (
              
              <div>
                <NavLink
                    to="Edit"
                    style={{ textDecoration: "underline" ,color:{delColor},cursor: "pointer"}}
                    state={{ flag: "E", id: params.row.id, data:params.row }}
                    className={classes.label_text}>
                    <EditOutlinedIcon/>
                </NavLink> 
                 <DeleteOutlineIcon style={{cursor: "pointer",color:{delColor}}} onClick={() => showDeleteDialog(params.row.divnbr, params.row.prefLocation)} />
            </div>
            )*/

        )}
    },
    
    
  ];
 
return(<div className={classes.pagemargin}>
        <AllControlSearchView />
        <div className={classes.pagetitle}>Location Controls</div> 
        <div className={classes.icon_text_wrap}>
            <div  className={classes.icon_text}>
                <AddPlusIcon />
                <NavLink
                    to={"Add"} 
                    style={{textDecoration: "underline"}}
                    state={{  flag: "A", isSearch: true }}
                    className={classes.label_text}>
                    Add
                </NavLink>
             </div> 
        </div>
     
        <div className={classes.searchbox}>
        
        <SnackBar
        open={open}
        message={message}
        severity={severity}
        onClose={handleAlertNotifClose}
        ></SnackBar>

    <Grid container spacing={3}>        
    <Grid key={0} item xs={2}>
      <DivisionDropDownComp
      onDivChange={e => onDivDropDownSelect(e)}>
      </DivisionDropDownComp>
    </Grid>
    <Grid key={1} item xs={2}>
     <FormControl  style={{minWidth: '100%'}}>
      <TextField 
      label="Location (Opt)"
      onChange={(e) => setPrefLocation(e.target.value)}
      value={prefLocation}
       />
    </FormControl>
    </Grid>
    
    <Grid key={1} item xs={4}>
     <Button style={{
                marginLeft: "10px",
                paddingTop: "14px",
                paddingBottom: "14px",
                paddingLeft: "80px",
                paddingRight: "80px",
                marginRight: "5px"
              }} onClick={handleSearch}>Search</Button>
     </Grid>         
    </Grid> 

    </div>
    <LocationControlsDataGrid columns= { columns} rows = {searchValue} width={"90%"} height={600} disableSelectionClick={true} />          
    {openLocDialog && <EventLocationsDialog onCloseDialog={onCloseDialog} data={selectedLocLinkData}/>}
    {openDeleteDialog && <DeleteEventDialog onCloseDialog={onCloseDialog} onDeleteCallback={onDeleteCallback} data={selectedRowData} divNbr = {deleteDiv} locNbr = {deleteLoc} flag = {"S"} />}
    {openDuplicateDialog && <DuplicateEventDialog onCloseDialog={onCloseDialog} onDuplicateCallback={onDuplicateCallback} data={selectedRowData} flag = {"S"} eventId={selectedRowData.eventid} prefLocation={selectedRowData.prefLocation} divNbr = {duplicDiv} locNbr = {duplicLoc}/>}


  </div>); 

}

export default LocationControlsSearch;